import { OAuthService } from 'angular-oauth2-oidc';
import { StorageService } from './services/storage/storage.service';
import { AuthConfigService } from './sso.config';

export function initializeAuth(
    oauthService: OAuthService,
    authConfigService: AuthConfigService,
    storageService: StorageService
) {
    // const configureOAuth = (clientId: string): void => {
    //     const type = userService.user?.userType;
    //     const idToken = oauthService.getIdToken();

    //     const idTokenFromLocalStorage = localStorage.getItem('id_token');
    //     if (idTokenFromLocalStorage === 'null') {
    //         localStorage.setItem('id_token', idToken);
    //     }

    //     let config = this.authConfigService.authConfig;
    //     config.logoutUrl = `${config.authBase}/realms/${clientId}/protocol/openid-connect/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${encodeURIComponent(config.postLogoutRedirectUri)}`;
    //     if (type === UserType.SUBSCRIPTION)
    //         config.postLogoutRedirectUri = config.postLogoutRedirectUri;

    //     if (!config.issuer.endsWith(clientId)) {
    //         config.issuer = config.authBase + '/realms/' + clientId;
    //     }
    //     this.oauthService.configure(config);
    //     this.oauthService.setupAutomaticSilentRefresh();
    // };

    return () => {
        const clientId = storageService.getClientId();
        if (!clientId) {
            return Promise.resolve(); // or redirect to login
        }

        const config = authConfigService.authConfig;
        config.issuer = `${config.authBase}/realms/${clientId}`;
        oauthService.configure(config);

        // configureOAuth(clientId);

        return oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
            const token = sessionStorage.getItem('access_token');
            if (token) {
                localStorage.setItem('access_token', token);
            }
            oauthService.setupAutomaticSilentRefresh();
        });
    };
}
